export const getScrollKey = (): string => {
  return `scrollposition-${window.location.pathname}${window.location.search}`
}

export const cacheScrollPosition = (scrollY: number = window.scrollY): void => {
  window.sessionStorage.setItem(getScrollKey(), scrollY.toString())
}

export const getCachedScrollPosition = (): number | undefined => {
  const storedValue = window.sessionStorage.getItem(getScrollKey())

  if (storedValue !== null) {
    return parseInt(storedValue, 10)
  }
}
